import { useQuery } from "@tanstack/react-query"
import { productOverviewRoute, type ProductOverview } from "@nova-ai/product-detail-contract"

import { apiFetch } from "../lib/api"
import { queryKeys } from "./query-keys"

export function useProductOverview(configSku: string, enabled = true) {
  return useQuery({
    queryKey: queryKeys.productOverview(configSku),
    enabled: enabled && configSku.length > 0,
    queryFn: async ({ signal }) => {
      const result = await apiFetch<ProductOverview>(productOverviewRoute(configSku), {
        signal,
      })
      if (!result.ok) {
        throw new Error(result.error.message)
      }
      return result.value
    },
  })
}
